import type { DateString, ID } from '../common';

// Vehicle type as const object (following TypeScript Style Guide - no enums)
export const VEHICLE_TYPE = {
  CAR: 'CAR',
  MOTORCYCLE: 'MOTORCYCLE',
  ATV_QUAD: 'ATV_QUAD',
  SCOOTER: 'SCOOTER',
} as const;

export type VehicleType = (typeof VEHICLE_TYPE)[keyof typeof VEHICLE_TYPE];

// Vehicle type display labels for UI
export const VEHICLE_TYPE_LABELS: Record<VehicleType, string> = {
  CAR: 'Car',
  MOTORCYCLE: 'Motorcycle',
  ATV_QUAD: 'ATV/Quad',
  SCOOTER: 'Scooter',
} as const;

export type VehicleGroup = {
  id: ID;
  vehicleType: VehicleType;
  name: string;
  description?: string | null;
  ordering: number;
  isActive: boolean;
  // Age Limits when the list sends them. Absent means unknown (read the
  // group's constraints); null means the group sets no such limit.
  minAge?: number | null;
  maxAge?: number | null;
  minLicenseYears?: number | null;
  createdAt: DateString;
  updatedAt: DateString;
  // Omitted by the backend when a Rental is in scope
  rental?: {
    id: string;
    name: string;
  } | null;
};

// The create sends all three Age Limits; PATCH /groups/:id takes none of them.
export type CreateVehicleGroupInput = Omit<
  VehicleGroup,
  'id' | 'createdAt' | 'updatedAt' | 'rental'
>;

export type UpdateVehicleGroupInput = Partial<
  Omit<CreateVehicleGroupInput, 'minAge' | 'maxAge' | 'minLicenseYears'>
>;
